module.exports = __webpack_public_path__ + "media/images/restaurant/tw_sarvicegenre_bg01-4c548a99070a7f144aff792b8d4d083a.png";